import React from 'react';
import PropTypes from 'prop-types';
import { useAuthContext } from 'AuthContext';
import useIsMobile from 'lib/useIsMobile';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useApolloClient } from '@apollo/client';
import Main from '../../ripple/Containers/Main';
import Header from './Alcohol-HEAD.png';
import MobileHeader from './Alcohol-HEAD-Mobile.png';
import Step1 from './Step1a.png';
import Step2 from './Step2.png';
import Step3 from './Step3.png';
import Step4 from './Step4.png';
import HowItWorks from './howitworks.png';
import SvedkaBanner from './Banner-Svedka.png';
import MondaviBanner from './Banner-Mondavi.png';
import classes from './index.scss';
import { GET_PROFILE_INFO } from '../../schema/apolloQueries/commonQueries';

const BarrelOfEvents = ({ router }) => {
  const isMobile = useIsMobile();
  const client = useApolloClient();
  const profileData = client.readQuery({
    query: GET_PROFILE_INFO,
  });
  const loggedIn = profileData?.getProfile?.loggedIn;
  const { showSignInDialog } = useAuthContext();

  const howItSteps = () => {
    const items = [{
      step: 1,
      title: 'APPLY',
      description: 'Browse our alcohol events and answer a few questions to apply! It will take 10 seconds, we promise.',
      icon: Step2,
    }, {
      step: 2,
      title: 'TRY',
      description: 'If selected to participate, you’ll receive a pack at home to try the product with friends and family. Go ahead— touch, sniff, taste, and savor the experience!',
      icon: Step3,
    }, {
      step: 3,
      title: 'SHARE',
      description: 'Spread the love for the new product with your friends and family online—write reviews and post on social to give your honest opinion! ',
      icon: Step4,
    }];
    return items.map((item, index) => (
      <Grid className={classes.step} item lg={4} md={4} sm={12} xs={12} style={index < 2 && !isMobile ? { borderRight: '1px solid black' } : {}}>
        {isMobile ? (<img src={item.icon} className={classes.icon} alt={item.title} />) : '' }
        <Typography style={isMobile ? { textAlign: 'left' } : { textAlign: 'center' }}>
          <div className={classes.stepNumber}>{item.step}</div>
          <div className={classes.stepText}>{item.title}</div>
        </Typography>
        <p className={classes.stepDescription}>{item.description}</p>
        {!isMobile ? (<img src={item.icon} className={classes.icon} alt={item.title} />) : ''}
      </Grid>
    ));
  };
  return (
    <Main
      title='Home'
      padContent={false}
      padContainerBottom={false}
    >
      <Box className={classes.container}>
        <img alt='Header' src={isMobile ? MobileHeader : Header} />
        <Grid container className={classes.content}>
          {!isMobile && (
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <img alt='Step 1' src={Step1} />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={8} lg={8} style={{ display: 'table' }}>
            <div className={classes.stepADesc}>
              Try the latest beer, wine, spirits, and seltzers from awesome brands like Lagunitas, Robert Mondavi, Hennessy,
              and Monaco! Join our Ripple Street community now and apply to our alcohol events - leave the rest to us!
              Don’t be surprised if you receive something in the mail with free products, branded swag, and more <span aria-label='smile' role='img'>&#128522;</span>
            </div>
          </Grid>
          {isMobile && (
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <img alt='Step 1' src={Step1} />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'center', margin: '40px 0' }}>
            <button
              type='button'
              className={classes.signup}
              onClick={() => {
                if (!loggedIn) {
                  showSignInDialog();
                } else {
                  router.push('/discover/events');
                }
              }}
            >
              SIGN ME UP!
            </button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'center', marginTop: 10 }}>
            <img alt='Step 1' src={HowItWorks} className={classes.howitworks} />
          </Grid>
          <Grid container xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'center', marginTop: 10 }}>
            {howItSteps()}
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.eventsContainer}>
        <Typography style={{ textAlign: 'center', color: '#fff', fontSize: '1.7em', fontWeight: 700, margin: 20, marginBottom: 30 }}>Check out our most popular open events</Typography>
        <Grid container>
          <Grid item lg={6} md={6} sm={12} xs={12} style={{ cursor: 'pointer' }} onClick={() => router.push('/events/svedkahalloween')}>
            <div className={classes.applyNow}>
              <div className={classes.applyNowText}>APPLY NOW!</div>
              <div className={classes.limitedSpots}>Limited Spots Available</div>
            </div>
            <div className={classes.eventBanner}>
              <img alt='Svedka' src={SvedkaBanner} />
            </div>
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12} style={{ cursor: 'pointer' }} onClick={() => router.push('/events/rmpsspiritsbarrelsaged')}>
            <div className={classes.applyNow}>
              <div className={classes.applyNowText}>APPLY NOW!</div>
              <div className={classes.limitedSpots}>Limited Spots Available</div>
            </div>
            <div className={classes.eventBanner}>
              <img alt='Mondavi' src={MondaviBanner} />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'center', margin: '40px 0' }}>
            <button type='button' className={classes.signup} style={{ border: '3px solid #fff' }} onClick={() => router.push('/discover/events')}>VIEW ALL</button>
          </Grid>
        </Grid>
      </Box>
    </Main>
  );
};

BarrelOfEvents.propTypes = {
  router: PropTypes.object.isRequired,
};

export default BarrelOfEvents;
